import React, {useState} from "react";
import Api from "../../Api/api";
import {BeatLoader} from "react-spinners";
import {ToastContainer, toast} from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const toastConfig = {
    position: "top-center",
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
};

const SupportPage = () => {
    const [formData, setFormData] = useState({
        name: "", email: "", subject: "", message: "",
    });

    const [submitted, setSubmitted] = useState(false);
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);

    const handleChange = (e) => {
        const {name, value} = e.target;
        setFormData({...formData, [name]: value});
        setErrors({...errors, [name]: ""});
    };

    const validateForm = () => {
        const newErrors = {};
        if (!formData.name) newErrors.name = "Bitte geben Sie Ihren Namen ein.";
        if (!formData.email) {
            newErrors.email = "Bitte geben Sie Ihre E-Mail-Adresse ein.";
        } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
            newErrors.email = "Ungültige E-Mail-Adresse.";
        }
        if (!formData.message) newErrors.message = "Bitte geben Sie Ihre Nachricht ein.";
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) return;

        setLoading(true);

        Api()
            .post("/support", formData)
            .then((response) => {
                if (response.status === 200) {
                    setFormData({name: "", email: "", subject: "", message: ""}); // Reset form
                    setErrors({});
                    setSubmitted(true);
                    toast.success("Ihre Nachricht wurde erfolgreich gesendet.", toastConfig);
                } else {
                    toast.error("Fehler beim Senden der Nachricht. Bitte versuchen Sie es später erneut.", toastConfig);
                }
            })
            .catch((error) => {
                console.error("Error:", error);
                toast.error("Fehler beim Senden der Nachricht. Bitte versuchen Sie es später erneut.", toastConfig);
            })
            .finally(() => {
                setLoading(false);
            });
    }

    // Check if the form is valid
    const isFormValid = () => {
        return (formData.name.trim() !== "" && formData.email.trim() !== "" && /\S+@\S+\.\S+/.test(formData.email) && formData.message.trim() !== "");
    };

    return (<div className="dashboardContainer w-full">
        {/* Toast Container */}
        <ToastContainer/>

        <div className="flex justify-start items-center content-center pb-5">
            <h2 className="text-2xl lg:text-left">Support & Hilfe</h2>
        </div>

        <div className="bg-white p-6 rounded-lg shadow-md w-full">
            {!submitted ? (<div className="flex content-center justify-center">
                <p className="mb-6">
                    Hier können Sie eine Nachricht an unser Support-Team senden. Wir helfen Ihnen gerne weiter.
                </p>
            </div>) : <div className="flex content-center justify-center"></div>}
            <div className="flex content-center justify-center">
                {submitted ? (<div className="bg-tahiti text-white p-3 text-xl font-medium py-6">
                    Die Supportnachricht wurde erfolgreich versandt.
                </div>) : (<form onSubmit={handleSubmit} className="space-y-4 w-1/2">
                    <div>
                        <label htmlFor="name" className="block text-sm font-medium text-gray-700 text-left">
                            Ihr Name
                        </label>
                        <input
                            type="text"
                            id="name"
                            name="name"
                            value={formData.name}
                            onChange={handleChange}
                            className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                        />
                        {errors.name && <p className="text-red-500 text-sm mt-1 text-left">{errors.name}</p>}
                    </div>

                    <div>
                        <label htmlFor="email" className="block text-sm font-medium text-gray-700 text-left">
                            Ihre E-Mail-Adresse
                        </label>
                        <input
                            type="email"
                            id="email"
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                            className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                        />
                        {errors.email && <p className="text-red-500 text-sm mt-1 text-left">{errors.email}</p>}
                    </div>

                    <div>
                        <label htmlFor="subject" className="block text-sm font-medium text-gray-700 text-left">
                            Betreff
                        </label>
                        <input
                            type="text"
                            id="subject"
                            name="subject"
                            value={formData.subject}
                            onChange={handleChange}
                            className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                        />
                    </div>

                    <div>
                        <label htmlFor="message" className="block text-sm font-medium text-gray-700 text-left">
                            Ihre Nachricht
                        </label>
                        <textarea
                            id="message"
                            name="message"
                            value={formData.message}
                            onChange={handleChange}
                            rows="4"
                            className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                        />
                        {errors.message && <p className="text-red-500 text-sm mt-1 text-left">{errors.message}</p>}
                    </div>

                    <button
                        type="submit"
                        disabled={!isFormValid() || loading}
                        className={`w-1/4 px-4 py-2 bg-[rgb(58,70,169)] text-white rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 
                            ${!isFormValid() || loading ? "opacity-50 cursor-not-allowed" : "hover:bg-[rgb(58,70,169)]"}`}
                    >
                        {loading ? (<BeatLoader size={10} color="#ffffff"/>) : ("Support-Anfrage senden")}
                    </button>
                </form>)}
            </div>
        </div>
    </div>);
};

export default SupportPage;
